import React from "react";
import { UseFormReturn } from "react-hook-form";

import { Box, Typography } from "@mui/material";

import {
  AudioAndMusicData,
  CreditsAndAwardsData,
  DetailsData,
  LanguageAndSubtitlesData,
  ThumbUpload,
  TitleAndSynopsisData
} from "./index";

import { DefaultTypedResponse } from "models/response";
import { Tag } from "models";

import { MetadataSectionProps, MetadataSectionState } from "./models";

import { t, Trans } from "@lingui/macro";
import { ZPlayChipList } from "commons/fields";
import { ContentProducerService } from "services/content-producer-service";
import { withSnackbar, WithSnackbarProps } from "notistack";
import { ZPlayLoader } from "commons";
import { CreateAndEditTagModal } from "components/backoffice/tag";


class MetadataSection extends React.Component<MetadataSectionProps & UseFormReturn & WithSnackbarProps, MetadataSectionState> {

  constructor(props: any) {
    super(props);
    this.state = {
      openCreateTagModal: false,
      isLoading: false,
      tagList: this.props.collectionsList.tagList.list
    };
  }

  private openCreateTagModal = (): void => {
    this.setState(() => ({openCreateTagModal: true}));
  };

  private closeCreateTagModal = (): void => {
    this.setState(() => ({openCreateTagModal: false}));
  };

  private createTagCallback = (data: any) => {
    this.props.enqueueSnackbar(t({
      id: "ms-success-create-tag",
      message: "Il tag è stato creato con successo"
    }), {
      variant: "success",
    });
    this.getTagsList();
    this.closeCreateTagModal();
  };

  private createTagErrorCallback = (err: any) => {
    this.props.enqueueSnackbar(t({
      id: "ms-error-create-tag",
      message: "Si è verificato un errore nella creazione del tag"
    }), {
      variant: "error",
    });
    this.closeCreateTagModal();
  };

  private getTagsList = (): void => {
    this.setState(() => ({
      isLoading: true,
    }));
    ContentProducerService.getTagList(this.getTagCallback, this.getTagErrorCallback);
  };

  private getTagCallback = (data: DefaultTypedResponse<Tag>): void => {
    this.setState(() => ({
      tagList: data.list,
      isLoading: false
    }));
  };

  private getTagErrorCallback = (err: any): void => {
    this.props.enqueueSnackbar(t({
      id: "ms-error-get-tags",
      message: "Si è verificato un errore. Non è stato possibile recuperare i dati"
    }), {
      variant: "error",
    });
    this.setState(() => ({
      isLoading: false,
    }));
  };

  private getCSVSubtitles = ():string => {
    if(!this.props.content)
      return ""
    if(!this.props.content.contentAdditionalInfos)
      return ""
    if(!this.props.content.contentAdditionalInfos.contentSubmitionType)
      return ""
    if(!this.props.content.contentAdditionalInfos.csvSubtitles)
      return ""
    return this.props.content.contentAdditionalInfos.csvSubtitles
  }

  render() {
    return (<>
      <Typography
        color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}
        variant="h3"
        textAlign="center"
        mb={3}>
        <Trans id={"df-metadata-section"}>Metadata</Trans>
      </Typography>
      <Typography
        mb={5}
        variant={"body2"}
        color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
        <Trans id={"df-metadata-info"}> Per poter creare un contenuto è necessario inserire almeno un titolo e una sinossi. È inoltre richiesto di inserire un'immagine di copertina. </Trans>
      </Typography>

      {/* UPLOAD ANTEPRIMA */}
      {<ThumbUpload
        fileImgName={this.props.fileImgName}
        fileImgURL={this.props.fileImgURL}
        isThumbUploaded={this.props.isThumbUploaded}
        removeFileImg={this.props.removeFileImg}
        parseFileImg={this.props.parseFileImg}
      />}

      {/* ACCORDION */}
      <Box sx={{ mt: 4 }}>
        <TitleAndSynopsisData
            languageList={this.props.collectionsList.languageList.list}
            {...this.props} />
        <DetailsData
            countryList={this.props.collectionsList.countryList.list}
            genreList={this.props.collectionsList.genreList.list}
            contentIssuesList={this.props.collectionsList.contentIssuesList.list}
            seriesList={this.props.collectionsList.seriesList.list}
            {...this.props} />
        <CreditsAndAwardsData
            festivalList={this.props.collectionsList.festivalList.list}
            awardList={this.props.collectionsList.awardList.list}
            {...this.props} />
        <LanguageAndSubtitlesData
            languageList={this.props.collectionsList.languageList.list}
            csvSubtitles={this.getCSVSubtitles()}
            {...this.props} />
        <AudioAndMusicData {...this.props} />
      </Box>

      {/* TAG LIST */}
      {!this.state.isLoading && <ZPlayChipList
          chipsList={this.state.tagList}
          selectedChipsIds={this.props.selectedTags? this.props.selectedTags : []}
          color={process.env.REACT_APP_BACKOFFICE_CHIP_COLOR_TAG}
          updateListCallback={this.props.updateContentTagList}
          createChipCallback={this.openCreateTagModal}
          title={"Tag"}
          titleId={"zpcl-tag-label"}
          textId={"zpcl-tag-explanation"}
          text={"Scegli e seleziona i tag sottostanti per aggiungerli alla lista dei tag del tuo contenuto. Puoi inoltre creare dei tag personalizzati schiacciando sull'apposito bottone."}
      />}


      {/*<TagList updadateContentTagList={this.props.updadateContentTagList} />*/}

      {this.state.openCreateTagModal && <CreateAndEditTagModal 
          createTagCallback={this.createTagCallback} 
          createTagErrorCallback={this.createTagErrorCallback} 
          closeModal={this.closeCreateTagModal}/>}
          
      {this.state.isLoading && <ZPlayLoader />}
    </>)
  }
}

export default withSnackbar(MetadataSection);